import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import AppAppBar from '../modules/views/AppAppBar';
import { Container, Paper, Tab, Tabs, Typography } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import reportActions from '../actions/reportActions';
import ModalSpinner from '../modules/components/ModalSpinner';
import AppBar from '../modules/components/AppBar';
import Toolbar from '../modules/components/Toolbar';

const AssignmentsReport = ({ location }) => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = React.useState(0);

  const { assignmentsReportData, queryingAssignmentsReportData } = useSelector(
    (state) => state.reports
  );

  const engineeringAssignments = assignmentsReportData.locationAssignments
    ?.filter((assignment) => assignment.correctRole === 'ENGINEERING')
    .map((assignment) => {
      if (assignment.email === null) {
        assignment.email = 'Not Assigned';
      }
      return assignment;
    });

  const railroadAssignments = assignmentsReportData.locationAssignments
    ?.filter((assignment) => assignment.correctRole === 'RAILROAD')
    .map((assignment) => {
      if (assignment.email === null) {
        assignment.email = 'Not Assigned';
      }
      return assignment;
    });
  const pmAssignments = assignmentsReportData.permitManagerAssignments?.sort((a, b) =>
    a.permitType.localeCompare(b.permitType)
  );

  React.useEffect(() => {
    dispatch(reportActions.getAssignmentsReportData());
  }, [dispatch]);

  const locationAssignmentsColumns = React.useMemo(
    () => [
      {
        accessorKey: 'territoryName',
        header: 'Territory Name',
      },
      {
        accessorKey: 'email',
        header: 'Assigned To',
      },
    ],
    []
  );
  const pmAssignmentsColumns = React.useMemo(
    () => [
      {
        accessorKey: 'permitType',
        header: 'Permit Type',
      },
      {
        accessorKey: 'territoryName',
        header: 'Territory Name',
      },
      {
        accessorKey: 'email',
        header: 'Assigned To',
      },
    ],
    []
  );

  return (
    <>
      <ModalSpinner open={queryingAssignmentsReportData} />
      <AppAppBar pathname={location.pathname} />
      <Container sx={{ marginTop: '10px' }}>
        <AppBar
          component="div"
          color="primary"
          position="static"
          elevation={0}
          sx={{ marginBottom: '10px' }}
        >
          <Toolbar>
            <Typography color="inherit" variant="h5" component="h1">
              Assignments
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper>
          <Tabs
            value={selectedTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(evt, newValue) => setSelectedTab(newValue)}
            aria-label="disabled tabs example"
          >
            <Tab label="Permit Manager"></Tab>
            <Tab label="Engineering"></Tab>
            <Tab label="Railroad"></Tab>
          </Tabs>
        </Paper>
        {selectedTab === 0 && (
          <MaterialReactTable
            columns={pmAssignmentsColumns}
            data={pmAssignments || []}
            title="Permit Manager Assignments"
            initialState={{ showColumnFilters: true }}
          />
        )}
        {selectedTab === 1 && (
          <MaterialReactTable
            columns={locationAssignmentsColumns}
            data={engineeringAssignments || []}
            title="Engineering Assignments"
            initialState={{ showColumnFilters: true }}
          />
        )}
        {selectedTab === 2 && (
          <MaterialReactTable
            columns={locationAssignmentsColumns}
            data={railroadAssignments || []}
            title="Railroad Assignments"
            initialState={{ showColumnFilters: true }}
          />
        )}
      </Container>
    </>
  );
};

AssignmentsReport.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default AssignmentsReport;
